<template>

        <header class="header-light">
     <div
        id="header-top"
      >
        <div class="container-fluid">
          <div class="row align-items-center justify-content-between w-100 m-0">
           <div class="col-xl-2 col-lg-2 col-md-2 col-6">
            <div class="d-flex align-items-center justify-content-start text-white">
            Logo
            </div>
            </div>
            <div class="col-xl-7 col-lg-7 col-md-7 col-6">
          <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-4 col-6">
              <div class="d-flex align-items-center text-white">
                <router-link to="/"> الرئيسية
                  </router-link>
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-4 col-6">
              <div
                class="d-flex align-items-center justify-content-center text-white"
              >
                <select class="nav-select" aria-label="  اللوائح و الأنظمة "  >
                  <option selected>  اللوائح و الأنظمة </option>
              <option value="2"> المؤسسات </option>
              <option value="1">الشركات</option>
            </select>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-6">
              <!-- <div
                class="d-flex align-items-center justify-content-end text-white"
              >
              <router-link to="/">
                <vue-feather
                        size="14"
                        stroke="#fff"
                        type="log-out"
                      ></vue-feather>
                 تسجيل خروج
                  </router-link>
                  </div> -->
          </div>
            </div>
          </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-6">
              <div class="d-flex align-items-center justify-content-end ">
                <div class="logo logo-border ">
                  <router-link to="/">
                    <img  src="@/assets/img/header/award.png" alt="logo" />
                  </router-link>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

    </header>
    <div class="company-header d-flex align-items-center justify-content-center flex-column ">
        <div class="company-title">صفحة الشركة</div>
        <div class="company-title-underline"></div>


    </div>

  </template>

  <script>
  export default {
    name: "HomeTwoHeader",
    data() {
      return {
        isSticky: false,
        searchPopup: false,
        menuOption: {
          menuShow: false,
          menuSearch: false,
          homeDropdown: false,
          serviceDropdown: false,
          pagesDropDown: false,
          blogDropdown: false,
          aboutDropdown: false,
        },
      };
    },
    methods: {
      handleSticky() {
        if (window.scrollY > 80) {
          this.isSticky = true;
        } else {
          this.isSticky = false;
        }
      },
      handleSearch() {
        this.searchPopup = true;
      },
      handleClose() {
        this.searchPopup = false;
      },
    },
    mounted() {
      window.addEventListener("scroll", this.handleSticky);
    },
  };
  </script>
  <style lang="scss" scoped>
  .nav-select{
    background: transparent;
    color: #fff;
    option{
        color: #000;
    }
  }
  </style>